import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'projects/tools/src/public-api-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
